import React, { useState, useEffect, Fragment } from 'react';
import { useSnackbar } from 'notistack';
import { withRouter } from 'react-router';
import { TextField, Grid, Button, Dialog, DialogActions, DialogContent, DialogTitle, Table, TableHead, TableBody, TableCell, CircularProgress, TableRow, Tooltip, Tabs, Tab } from '@material-ui/core';
import {DropzoneArea} from 'material-ui-dropzone';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { read, utils } from 'xlsx';
import { GetApp } from '@material-ui/icons';
import { checkApiStatus, downloadFileType } from '../../../utils_v2';
import { globalPostService, globalExportService } from '../../../utils_v2/globalApiServices';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { trackActivity } from '../../../utils/mixpanel';
import { globalStaticPostService } from '../../../globalServices';
import { castleAirInstance } from '../../../shared_elements/components';
const ImportSections = ({ params, toggleModalFn, importSections }) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [showMsg, setShowMsg] = useState(false);
    const [pres, setPres] = useState([]);
    const [presError, setPresError] = useState({});
    const [tempTabIndx, setTempTabIndx] = useState(0);
    const [questionsData, setQuestionsData] = useState([]);
    const onFieldChange = (e, keyParam, value, index) => {
        setPres(pres.map((item, itemIndex) => itemIndex !== index ? item : { ...item, [keyParam]: value }))
    }
    const onFieldChangeQuestion = (e, keyParam, value, index) => {
        setQuestionsData(questionsData.map((item, itemIndex) => itemIndex !== index ? item : { ...item, [keyParam]: value }))
    }
    const onRemove = (index) => {
        setPres(pres.filter((item, itemIndex) => itemIndex !== index))
    }
    const onRemoveQuestion = (index) => {
        setQuestionsData(questionsData.filter((item, i) => i !== index))
    }
    const onFilesDrop = (files) => {
        if (files && files.length > 0) {
            setLoading(true);
            const file = files[0];
            if (file instanceof Blob) {
                const reader = new FileReader();
                reader.onload = function (e) {
                    const buffer = e.target.result;
                    const wb = read(new Uint8Array(buffer));
                    if (wb.SheetNames.includes("Questions") && wb.SheetNames.includes("Sections") && castleAirInstance) {
                        const questionData = utils.sheet_to_json(wb.Sheets['Questions'], { blankRows: false });
                        const sectionData = utils.sheet_to_json(wb.Sheets['Sections'], { blankRows: false });
                        setQuestionsData(questionData)
                        setPres(sectionData)
                    } else {
                        const ws = wb.Sheets[wb.SheetNames[0]];
                        const data = utils.sheet_to_json(ws, { blankRows: false });
                        if (data.length === 0) {
                            enqueueSnackbar("Invalid Data", { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } })
                        }
                        setPres(data);
                    };
                }
                setLoading(false);
                reader.readAsArrayBuffer(file);
            } else {
                console.error("Invalid file object. Expected a Blob.");
            }
        }
    };
    const onImportSections = () => {
        // Validations for Template Import;
         let validateSection ={}
                validateSection={
                    ...validateSection,
                    section:pres[0] && pres[0]['Section Name'] ?'': pres?.length ?'Please Enter Section Name.':'',
                    questionSection:castleAirInstance? questionsData[0]? questionsData[0]['Section Name'] ?'':'Please Enter Section Name.':'':'',
                }
                if(validateSection?.section || validateSection?.questionSection ){
                    enqueueSnackbar('Please enter mandatory details to proceed.', { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } })
                    setPresError(validateSection)
                }else{
        let payload = questionsData.length ? { main_sections: pres, questions: questionsData } : { main_sections: pres }
        setLoading(true); setShowMsg(true)
        globalStaticPostService(`technical/v2/workorder/${importSections?.slug}/workbook/import/?asset_type=${params.type}`, payload)
            .then(response => {
                setLoading(false); setShowMsg(false)
                if (checkApiStatus(response)) {
                    enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } })
                    window.location.reload();
                    toggleModalFn();
                    trackActivity('Project Management', {
                        event_type: 'Section Import Success',
                        page_title: 'T013 Form',
                        workOrder_slug: params.workOrderSlug ? params.workOrderSlug : '',
                        request_body: pres ? pres : '',
                        response: response.data.data,
                        success_msg: response.data.message
                    });
                } else {
                    enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } })
                    trackActivity('Project Management', {
                        event_type: 'Section Import Failed',
                        page_title: 'T013 Form',
                        workOrder_slug: params.workOrderSlug ? params.workOrderSlug : '',
                        request_body: pres ? pres : '',
                        error_msg: response?.data?.data,
                        error_source: 'Backend'
                    });
                }
            })
        }
    }
    const downloadSampleTemplate = () => {
        globalExportService(`technical/v2/workbook/sample-import-template/`)
            .then(response => {
                downloadFileType(response, 'T013_Sample_Template.', 'xls')
                trackActivity('Project Management', {
                    event_type: 'Sample Template Downloaded',
                    page_title: 'T013 Form',
                    workOrder_slug: params.workOrderSlug ? params.workOrderSlug : '',
                    file_name: 'T013_Sample_Template',
                    file_extension: 'xls'
                });
            })
    }
    return (
        <Fragment>
            <Dialog
                open={importSections.modal}
                onClose={toggleModalFn}
                className='project-management-modal'
                maxWidth='lg'
            >
                <DialogTitle id="scroll-dialog-title">
                    Import New Section(s)
                </DialogTitle>
                <DialogContent dividers={true}>
                    <div style={{ width: "828px", height: "378px" }}>
                        <Grid container spacing={1}>
                            <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '100%' }}>
                                <span> Refer the sample template </span>
                                <Button style={{ fontFamily: '"Conv_IBMPlexSans-Bold"', fontWeight: '700' }} size='small' color='primary' variant='text' aria-controls="simple-menu" aria-haspopup="true" onClick={downloadSampleTemplate} endIcon={<ArrowDropDownIcon fontSize='small' />}> Download </Button>
                            </div>
                            <Grid item md={12}>
                                <DropzoneArea
                                    acceptedFiles={['.xls, .xlsx']}
                                    filesLimit={1}
                                    maxFileSize={10428800}
                                    showPreviewsInDropzone={false}
                                    useChipsForPreview={false}
                                    showPreviews={false}
                                    dropzoneText={<p style={{ fontSize: '13px' }}>Drag & Drop Documents<br /> OR <br /> Click Here<br /> </p>}
                                    dropzoneClass="drag-drop-cnt"
                                    maxWidth="sm"
                                    showAlerts={['info', 'error']}
                                    alertSnackbarProps={{ anchorOrigin: { vertical: 'top', horizontal: 'right' } }}
                                    clearOnUnmount={true}
                                    onChange={(files) => onFilesDrop(files)}
                                />
                                <div>
                                    {questionsData?.length && castleAirInstance ?
                                        <Tabs
                                            value={tempTabIndx}
                                            onChange={(event, newValue) => { setTempTabIndx(newValue) }}
                                            indicatorColor="primary"
                                            textColor="primary"
                                        >
                                            <Tab label='Sections' />
                                            <Tab label='Questions' />
                                        </Tabs> : null}
                                    {
                                        tempTabIndx == 0 ?
                                            pres.length ?
                                                <div style={{ overflowX: 'auto' }}>
                                                <Table className='mui-table-format'>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell>Section Name<sup>*</sup></TableCell>
                                                            <TableCell>Sub Section Name</TableCell>
                                                            <TableCell>Checklist</TableCell>
                                                            <TableCell>Notes</TableCell>
                                                           {castleAirInstance? <TableCell>Finding Summary</TableCell>:null}
                                                           {castleAirInstance? <TableCell>Summary Notes</TableCell>:null}
                                                            <TableCell>Action</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        { /* generate row for each president */
                                                            pres.map((pre, index) => (
                                                                <TableRow>
                                                                    <TableCell>
                                                                        <div style={{ width: '200px' }}>
                                                                            {
                                                                                <TextField
                                                                                    required
                                                                                    id={`name_${index}`}
                                                                                    fullWidth
                                                                                    margin="none"
                                                                                    value={pre['Section Name'] || ''}
                                                                                    onChange={(e) => onFieldChange(e, 'Section Name', e.target.value, index)}
                                                                                    InputLabelProps={{ shrink: true }}
                                                                                    variant='outlined'
                                                                                    error={!!presError?.section && index ===0}
                                                                                    helperText={index ===0 ?presError?.section:''}
                                                                                    onFocus={()=>setPresError({...presError,section:''})}
                                                                                /> 
                                                                            }
                                                                        </div>
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        <div style={{ width: '200px' }}>
                                                                            { 
                                                                                <TextField
                                                                                    required
                                                                                    id={`Sub-Section_${index}`}
                                                                                    fullWidth
                                                                                    margin="none"
                                                                                    value={pre['Sub Section Name']|| ''}
                                                                                    onChange={(e) => onFieldChange(e, 'Sub Section Name', e.target.value, index)}
                                                                                    InputLabelProps={{ shrink: true }}
                                                                                    variant='outlined'
                                                                                /> 
                                                                            }
                                                                        </div>
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {
                                                                            <div style={{ width: '200px' }}>
                                                                                <TextField
                                                                                    required
                                                                                    id={`Question_${index}`}
                                                                                    fullWidth
                                                                                    margin="none"
                                                                                    value={pre['Checklist']|| ''}
                                                                                    onChange={(e) => { onFieldChange(e, 'Checklist', e.target.value, index) }}
                                                                                    InputLabelProps={{ shrink: true }}
                                                                                    variant='outlined'
                                                                                />
                                                                            </div> 
                                                                        }
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        <div style={{ width: '200px' }}>
                                                                            <TextField
                                                                                required
                                                                                id={`Notes_${index}`}
                                                                                fullWidth
                                                                                margin="none"
                                                                                value={pre['Notes'] ? pre['Notes'] : ''}
                                                                                onChange={(e) => { onFieldChange(e, 'Notes', e.target.value, index) }}
                                                                                InputLabelProps={{ shrink: true }}
                                                                                variant='outlined'
                                                                            />
                                                                        </div>
                                                                    </TableCell>
                                                                    {castleAirInstance?
                                                                    <TableCell>
                                                                        <div style={{ width: '200px' }}>
                                                                            <TextField
                                                                                required
                                                                                id={`Finding_Summary${index}`}
                                                                                fullWidth
                                                                                margin="none"
                                                                                value={pre['Finding Summary'] ? pre['Finding Summary'] : ''}
                                                                                onChange={(e) => { onFieldChange(e, 'Finding Summary', e.target.value, index) }}
                                                                                InputLabelProps={{ shrink: true }}
                                                                                variant='outlined'
                                                                            />
                                                                        </div>
                                                                    </TableCell>:null}
                                                                    {castleAirInstance ?
                                                                    <TableCell>
                                                                        <div style={{ width: '200px' }}>
                                                                            <TextField
                                                                                id={`finding_summary_notes${index}`}
                                                                                fullWidth
                                                                                margin="none"
                                                                                value={pre['Finding Summary Notes'] ? pre['Finding Summary Notes'] : ''}
                                                                                InputLabelProps={{ shrink: true }}
                                                                                InputProps={{ readOnly: true }}
                                                                                variant='outlined'
                                                                            />
                                                                        </div>
                                                                    </TableCell> : null}
                                                                    <TableCell>
                                                                        {pres.length !== 1 ?
                                                                            <DeleteOutlineIcon color='secondary' onClick={() => onRemove(index)} /> : null
                                                                        }
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))
                                                        }
                                                    </TableBody>
                                                </Table>
                                                </div> : null :
                                            questionsData.length ?
                                                <Table className='mui-table-format'>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell>Section Name<sup>*</sup></TableCell>
                                                              <TableCell>Sub Section Name</TableCell>
                                                            <TableCell>Question(s)</TableCell>
                                                            <TableCell>Answer(s)</TableCell>
                                                            <TableCell>Note(s)</TableCell>
                                                            <TableCell>Action</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {questionsData.map((pres, index) => (
                                                            <TableRow key={index}>
                                                                <TableCell>
                                                                    <div style={{ width: '200px' }}>
                                                                    <TextField
                                                                        id={`${index}`}
                                                                        fullWidth
                                                                        margin="none"
                                                                        value={pres['Section Name']|| ''}
                                                                        InputLabelProps={{ shrink: true }}
                                                                        variant='outlined'
                                                                        onChange={(e) => onFieldChangeQuestion(e, 'Section Name', e.target.value, index)}
                                                                        error={!!presError?.questionSection && index ===0}
                                                                        helperText={index ===0 ?presError?.questionSection:''}
                                                                        onFocus={()=>setPresError({...presError,questionSection:''})}
                                                                    />
                                                                    </div>
                                                                </TableCell>
                                                                <TableCell>
                                                                    <div style={{ width: '200px' }}>
                                                                        {
                                                                            <TextField
                                                                                required
                                                                                id={`Sub-Section_${index}`}
                                                                                fullWidth
                                                                                margin="none"
                                                                                value={pres['Sub Section Name'] || ''}
                                                                                onChange={(e) => onFieldChangeQuestion(e, 'Sub Section Name', e.target.value, index)}
                                                                                InputLabelProps={{ shrink: true }}
                                                                                variant='outlined'
                                                                            />
                                                                        }
                                                                    </div>
                                                                </TableCell>
                                                                <TableCell>
                                                                     <div style={{ width: '200px' }}>
                                                                    <TextField
                                                                        id={`${index}`}
                                                                        fullWidth
                                                                        margin="none"
                                                                        value={pres['Question']|| ''}
                                                                        InputLabelProps={{ shrink: true }}
                                                                        variant='outlined'
                                                                        onChange={(e) => onFieldChangeQuestion(e, 'Question', e.target.value, index)}
                                                                    />
                                                                    </div>
                                                                </TableCell>
                                                                <TableCell>
                                                                    <div style={{ width: '200px' }}>
                                                                    <TextField
                                                                        id={`${index}`}
                                                                        fullWidth
                                                                        margin="none"
                                                                        value={pres['Answer']|| ''}
                                                                        InputLabelProps={{ shrink: true }}
                                                                        variant='outlined'
                                                                        onChange={(e) => onFieldChangeQuestion(e, 'Answer', e.target.value, index)}
                                                                    />
                                                                    </div>
                                                                </TableCell>
                                                                <TableCell>
                                                                        <div style={{ width: '200px' }}>
                                                                            <TextField
                                                                                required
                                                                                id={`Notes_${index}`}
                                                                                fullWidth
                                                                                margin="none"
                                                                                value={pres['Notes'] ? pres['Notes'] : ''}
                                                                                onChange={(e) => { onFieldChangeQuestion(e, 'Notes', e.target.value, index) }}
                                                                                InputLabelProps={{ shrink: true }}
                                                                                variant='outlined'
                                                                            />
                                                                        </div>
                                                                    </TableCell>
                                                                <TableCell>
                                                                    {questionsData.length !== 1 ?
                                                                        <DeleteOutlineIcon color='secondary' onClick={() => onRemoveQuestion(index)} /> : null
                                                                    }
                                                                </TableCell>
                                                            </TableRow>))}
                                                    </TableBody>
                                                </Table> : null

                                    }
                                </div>
                            </Grid>

                            <div>
                            <p className='attachment-note'>Note: Please download "Sample Section(s) template", edit the template in Excel and upload the same for further customization. </p>
                            {/* <p className='download-sample-temp' onClick={() => downloadSampleTemplate()} > <GetApp /> Download Sample Section(s) template</p> */}
                            </div>
                        </Grid>
                    </div>

                </DialogContent>
                <DialogActions style={{ display: 'contents' }}>
                    <div style={{ textAlign: 'right', margin: '10px', marginRight: '22px' }}>
                        <Button style={{ marginRight: "10px" }} disabled={isLoading} onClick={toggleModalFn} color="primary" size='small' variant='outlined'>Cancel</Button>
                        {pres.length ?
                            <Button disabled={isLoading} onClick={onImportSections} color="primary" size='small' variant='contained'>
                                {isLoading ? <CircularProgress size={20} /> : 'Save'}
                            </Button> : null
                        }
                    </div>
                    {showMsg ?
                        <span style={{ width: 'max-content', alignSelf: 'center', marginBottom: "10px" }} className='notes-block'>
                            Import in progress - Please don't refresh the page. This may take a few minutes. Thanks for your patience
                        </span>
                        : null}
                </DialogActions>
            </Dialog>
        </Fragment>
    )
}
export default withRouter(ImportSections)